<template>
  <div class="card__box--div">
    <div v-for="item in cards" :key="item.id">
      <a-card >
       <template slot="title">
          <p>{{item.title}}</p>
          <p>{{item.name}}</p>
        </template>
        <a-icon
          slot="extra" 
          @click.stop="copy(item)"
          style="font-size: 20px; color: #999999"
          type="copy"
        />
        <div class="card__con--div">
          <div>
            <img :src="item.smallImg" :style="item.smallImg?'':'visibility:hidden'"/>
            <!-- 遮罩 -->
            <div class="mask__div" :style="editStyle"></div>
            <div class="edittool-detalis" v-if="!visual">
              symbolID:{{item.symbolId}}
            </div>
            <!-- 编辑时出现 -->
            <div class="edittool" v-else>
              <div class="radio-position" @click="selectRadio(item)">
                <img
                  v-if="!item.showSelect"
                  style="width: 20px; min-height: 20px"
                  src="../../../assets/select.png"
                  alt=""
                />
                <img
                  v-if="item.showSelect"
                  style="width: 20px; min-height: 20px"
                  src="../../../assets/select-on.png"
                  alt=""
                />
              </div>
              <div class="edit-status">
                <div
                  @click.stop="editComponent(item)"
                  class="edit-button edit-other"
                >
                  编辑
                </div>
                <div class="edit-button" @click.stop="deleteComponent(item)">
                  删除
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="card__footer--div">
          <div class="body__author_box">
            <span class="body__author_text" :lines="undefined">
              作者:{{ item.realName }}
            </span>
            <span class="body__author_uploadtime_text" :lines="undefined"
              >上传时间: &nbsp;{{ item.createTime }}</span
            >
          </div>
          <div class="body-tags">
            <a-tag color="blue" v-for="(i, index) in 6" :key="index" class="tags">
              pink
            </a-tag>
          </div>
          <div class="body__style_div">
            <div class="body__style_box" @click.stop="praiseAdd(item)">
              <img class="body__give_like_image" 
              :src="
                  require(!item.praiseflag
                    ? '@/assets/component/list/imgpraise.png'
                    : '@/assets/component/list/praise.png')
                "
            
              /> 
              <span class="body__give_like_txt">{{item.likeNum || 0}}</span>
            </div>
            <div>
               <a-icon style="color: #999999" type="eye" />
              <span class="body__give_like_txt" style="margin-left: 5px">0</span>
            </div>
            <div class="body__download_div" @click.stop="downloadAdd">
              <img class="body__give_like_image" 
              :src="
                  require(msg.downloadflag
                    ? '@/assets/component/list/img_32360_0_1.png'
                    : '@/assets/component/list/download.png')
                "
            />
              <span class="body__give_like_txt">
                {{item.downloadNum || 0}}
              </span>
            </div>
          </div>
        </div>
      </a-card>
    </div>
  </div>
</template>
<script>
export default {
  name:'ListCard',
  props:{
    dataList:{
      type:Array
    },
    editStatus:{
      type:Boolean
    }
  },
  watch:{
    dataList(val){
      this.cards = val
      console.log(val,"Asdasfasfnkgjsa")
    },
    editStatus(val){
      console.log(val,"vallllllleditStatus")
      this.visual = val
      if (val){
        return this.editStyle = 'display:block;'
      }
      this.editStyle = ''
    }
  },
  data () {
    return {
      cards:[],
      msg: {
        praiseNum: 0,
        downloadNum: 0,
        praiseflag: true,
        downloadflag: true,
      },
      editStyle:'',
      visual:false,
      selectComponentIds:[]
    }
  },
  methods:{
    copy(val){
      if (this.editOrDelet == "编辑") {
        val.seensketch = true;
        // this.dataProcessing(val);
        this.$copyText(val.componentRoute).then(
          function (e) {
            val.seensketch = true;
          },
          function (e) {
            alert("Can not copy");
            console.log(e);
          }
        );
      } else {
        val.seensketch = false;
      }
    },
    selectRadio(item){ this.$emit('selectRadio',item)},
    editComponent(){},
    deleteComponent(){}
  }
}
</script>
<style lang="less" scoped>
@import './index.less';
</style>